import { ExcludeKeyword } from './excludeKeywordButton.types';

export const DEFAULT_EXCLUDE_KEYWORD: Readonly<ExcludeKeyword> = {
  excludeKeywordList: [],
  excludeKeywordSegmentedType: 'OR',
} as const;
